import React from "react";
import { AdvancedChart } from "react-tradingview-embed";
export default function Simplechart() {
  return (
    <div>
      <AdvancedChart
        widgetProps={{
          height: "600",
          symbol: "NASDAQ:AAPL",
          interval: "D",
          timezone: "Etc/UTC",
          theme: "dark",
          style: "1",
          locale: "br",
          toolbar_bg: "#f1f3f6",
          enable_publishing: false,
          allow_symbol_change: true,
          container_id: "tradingview_cddbb",
        }}
      />
    </div>
  );
}
